const checkoutCouponSelector = '.checkout-order__coupon';

const applyCheckoutCoupon = async (control) => {
  const input = control.querySelector('input');
  const button = control.querySelector('button');
  const error = control.querySelector('.checkout-order__coupon-error');
  const params = window.wc_checkout_params;
  const code = input?.value.trim();

  if (!code || control.classList.contains('is-updating')) return;

  if (!params?.wc_ajax_url || !params.apply_coupon_nonce) {
    error.textContent = control.dataset.error || 'Unable to apply coupon.';
    error.hidden = false;
    return;
  }

  control.classList.add('is-updating');
  control.setAttribute('aria-busy', 'true');
  button.disabled = true;
  error.hidden = true;

  try {
    const endpoint = params.wc_ajax_url.replace('%%endpoint%%', 'apply_coupon');
    const requestUrl = new URL(endpoint, window.location.href);
    requestUrl.host = window.location.host;
    requestUrl.protocol = window.location.protocol;
    const data = new URLSearchParams({
      security: params.apply_coupon_nonce,
      coupon_code: code,
      billing_email: document.querySelector('#billing_email')?.value || '',
    });
    const response = await fetch(requestUrl.toString(), {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('Coupon request failed');

    const markup = await response.text();
    const notice = new DOMParser().parseFromString(markup, 'text/html');
    const invalid = notice.querySelector('.woocommerce-error, .is-error');
    if (invalid) {
      error.textContent = invalid.textContent.trim();
      error.hidden = false;
      input.focus();
      return;
    }

    if (window.jQuery) {
      const body = window.jQuery(document.body);
      body.trigger('applied_coupon_in_checkout', [code]);
      body.trigger('update_checkout', { update_shipping_method: false });
    }
  } catch (requestError) {
    error.textContent = control.dataset.error || 'Unable to apply coupon.';
    error.hidden = false;
  } finally {
    control.classList.remove('is-updating');
    control.removeAttribute('aria-busy');
    button.disabled = false;
  }
};

document.addEventListener('click', (event) => {
  const button = event.target.closest?.('.checkout-order__coupon-apply');
  if (button) applyCheckoutCoupon(button.closest(checkoutCouponSelector));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || !event.target.matches?.('#checkout_coupon_code'))
    return;
  event.preventDefault();
  applyCheckoutCoupon(event.target.closest(checkoutCouponSelector));
});

const updateBillingFieldState = (row) => {
  if (!row) return;
  const field = row.querySelector('input.input-text, select');
  row.classList.toggle('is-filled', Boolean(field?.value));

  if (row.id === 'billing_country_field' && field?.tagName === 'SELECT') {
    const options = [...field.options].filter(
      (option) => !option.disabled && option.value !== ''
    );
    row.classList.toggle('is-single-option', options.length === 1);
  }
};

const initBillingFieldState = () => {
  const wrapper = document.querySelector(
    '.checkout-details .woocommerce-billing-fields__field-wrapper'
  );
  if (!wrapper) return;

  const refresh = () => {
    wrapper.querySelectorAll('.form-row').forEach(updateBillingFieldState);
  };
  refresh();

  wrapper.addEventListener('input', (event) => {
    updateBillingFieldState(event.target.closest('.form-row'));
  });
  wrapper.addEventListener('change', (event) => {
    updateBillingFieldState(event.target.closest('.form-row'));
  });

  new MutationObserver(refresh).observe(wrapper, {
    childList: true,
    subtree: true,
  });

  if (window.jQuery) {
    window.jQuery(document.body).on('country_to_state_changed', refresh);
    window.jQuery(wrapper).on('change', 'select', (event) => {
      updateBillingFieldState(event.target.closest('.form-row'));
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBillingFieldState);
} else {
  initBillingFieldState();
}
